import React from "react";
import styled from "styled-components";
import { PrimaryButton, ButtonRow } from "../../../../components/Buttons";

const Button = styled(PrimaryButton)`
  min-width: 150px;
  position: relative;
  font-size: 19px;
  font-weight: 600;
  height: 38px;
`;

const ConfirmButton = ({ onClick, text, disabled, style, inverted }) => {
  return (
    <ButtonRow justifyContent="center">
      <Button
        onClick={() => (onClick ? onClick() : null)}
        disabled={disabled}
        style={style}
        inverted={inverted}
      >
        {text}
      </Button>
    </ButtonRow>
  );
};

export default ConfirmButton;
